import AutoSave from '@components/common/form/formik/AutoSave';
import LabeledField from '@components/common/form/formik/input/LabeledField';
import { userValidationSchema } from '@data/user/userValidationSchema';
import { InstructorAuthContext } from '@src/authContexts';
import { Formik, Form } from 'formik';
import React, { useContext } from 'react';

const BioEditor: React.FC = () => {
  const { userDoc } = useContext(InstructorAuthContext);

  const userData = userDoc.data();

  return (
    <Formik
      validationSchema={userValidationSchema}
      initialValues={{ bio: userData?.bio }}
      onSubmit={() => undefined}
    >
      <Form className='mt-10'>
        <AutoSave<{ bio: string }>
          onSave={(values, isValid) => {
            if (isValid) {
              userDoc.ref.update(values);
            }
          }}
        />
        <LabeledField
          label='Bio'
          name='bio'
          className='align-middle'
          labelClassName='font-bold'
          as='textarea'
          rows={3}
          cols={20}
        ></LabeledField>
      </Form>
    </Formik>
  );
};

export default BioEditor;
